import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'App/store';
import { getStoreCategoryAction } from 'domains/PagoNubeOnboarding/StoreCategory/storeCategorySlice/storeCategorySlice';
import { getStoreCategoryState } from '../storeCategorySlice/storeCategorySelectors';

export const useGetStoreCategories = () => {
  const dispatch = useAppDispatch();
  const storeCategoryState = useSelector(getStoreCategoryState);

  const fetchStoreCategories = useCallback(() => {
    dispatch(getStoreCategoryAction());
  }, [dispatch]);

  return { fetchStoreCategories, storeCategoryState };
};

export default useGetStoreCategories;
